import React from 'react';
const starburst = Array.from({
  length: 48
}).map((_, i) => {
  const angle = Math.PI * 2 * i / 48;
  const r = i % 2 === 0 ? 50 : 44;
  return `${50 + r * Math.cos(angle)}% ${50 + r * Math.sin(angle)}%`;
}).join(', ');
export function GuaranteeSeal() {
  return <section aria-labelledby="guarantee-title" className="bg-[#F2E9FB] py-14 md:py-20" data-id="element-102" data-mp="2nsk6mci0c4m2">
      <div className="mx-auto max-w-xl px-6 text-center" data-id="element-103" data-mp="2nuwluhwds0vf">
        <div className="mx-auto flex h-52 w-52 items-center justify-center bg-[#C9A24A]" style={{
        clipPath: `polygon(${starburst})`
      }} aria-hidden="true" data-id="element-104" data-mp="203r6s4y9lcm6">
          <div className="flex h-[78%] w-[78%] items-center justify-center rounded-full bg-[#D9B860] p-1.5" data-id="element-105" data-mp="294fgwokjests">
            <div className="flex h-full w-full flex-col items-center justify-center rounded-full border-[3px] border-[#D9B860] bg-[#1E1A17] text-[#E9C873]" data-id="element-106" data-mp="250hkilmljw4f">
              <span className="font-display text-[15px] font-extrabold uppercase tracking-[0.18em]" data-id="element-107" data-mp="3ghr2f3q2ug3m">Garancia</span>
              <span className="text-[9px] tracking-[0.2em]" data-id="element-108" data-mp="32mbc4w4vv6ls">★★★</span>
              <span className="font-display text-5xl font-extrabold leading-none" data-id="element-109" data-mp="37m7haypbh42x">30</span>
              <span className="mt-1 font-display text-[15px] font-extrabold uppercase tracking-[0.18em]" data-id="element-110" data-mp="3bo1euy47tryv">Nap</span>
            </div>
          </div>
        </div>

        <h2 id="guarantee-title" className="mt-7 font-serif text-[1.65rem] font-semibold leading-snug text-ink [font-style:normal]" data-id="element-111" data-mp="3gmm5c5to0xa4">
          Elégedettségi garancia — 30 nap
        </h2>
        <div className="mt-4 space-y-4 text-[17px] leading-relaxed text-body" data-id="element-112" data-mp="2nz9uuu0s4fx6">
          <p data-id="element-113" data-mp="2sxb9n2r69t2u">
            Azonnal hozzáférsz az összes anyaghoz, közvetlenül e-mailben. Letöltöd a kézikönyvet, kiválasztod az első
            tevékenységeket, és otthon, a saját tempódban, nyomás nélkül elkezded.
          </p>
          <p className="font-bold text-ink" data-id="element-114" data-mp="208cqq3f86mwh">
            Ha az anyag nem olyan, amilyenre számítottál, 30 napon belül visszakérheted a vételárat.
          </p>
          <p data-id="element-115" data-mp="38icw4rzhdalf">
            Szeretnénk, ha kéznél lenne egy egyszerű, könnyen használható kreatív könyvtár, amely segít kifejezni, amit
            érzel, lecsendesíteni a gondolataidat, és néhány nyugodt pillanatot csak magadnak szánni.
          </p>
        </div>
      </div>
    </section>;
}